import Field from '../Field'
import * as S from './RadioGroup.styled'

const RadioGroup = ({
  label,
  name,
  options,
  required,
  error,
  direction,
  mobileDirection,
  defaultValue,
  ...restProps
}) => {
  return (
    <S.RadioGroup>
      <S.RadioGroupLabel>
        {label} {required && <span>(required)</span>}
      </S.RadioGroupLabel>
      <S.RadioGroupItems
        direction={direction}
        mobileDirection={mobileDirection}
      >
        {options.map((it, idx) => (
          <Field
            key={idx}
            {...restProps}
            type='radio'
            name={name}
            label={it.label}
            value={it.value}
            defaultChecked={it.value === defaultValue}
          />
        ))}
      </S.RadioGroupItems>
      {error && <S.Error>{error}</S.Error>}
    </S.RadioGroup>
  )
}

export default RadioGroup
